import React from "react";

export default function Price({ value, originalValue, vat }) {
    let showOriginalValue = originalValue && originalValue !== value;
    if (showOriginalValue) {
        showOriginalValue = parseInt(value.replace(/[^\d]/g, '')) < parseInt(originalValue.replace(/[^\d]/g, ''));
    }

    return (
      <div itemProp="offers" itemType="http://schema.org/Offer" className="item-pricing pricing">
        { showOriginalValue ? <s className="text-danger">{ originalValue }</s> : null }
        <span itemProp="price" className="item-price price">{value}</span>
        {vat ? <span className="item-vat price-vat">{vat}</span> : null}
      </div>
    );
}

Price.propTypes = {
    value: React.PropTypes.string.isRequired,
    originalValue: React.PropTypes.string,
    vat: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Atoms/Price.jsx